export const INSERT_EMOJI_BUTTON = 'insert-emoji-button';
export const INSERT_EMOJI_MODAL = 'insert-emoji-modal';
export const INSERT_EMOJI_MODAL_LIST_ITEM = 'insert-emoji-modal-list-item';
